import useScreenWidth from '@use/useScreenWidth';
import { reactive, watch } from 'vue';

const screenWidth = useScreenWidth();

interface IDeviceInfo {
  screen: 'mobile' | 'tablet' | 'desktop';
}

export default function useDeviceInfo(): IDeviceInfo {
  const deviceInfo: IDeviceInfo = reactive({
    screen: 'mobile',
  });

  const setScreenWidth = () => {
    if (screenWidth.value >= 992) {
      deviceInfo.screen = 'desktop';
    } else if (screenWidth.value >= 768) {
      deviceInfo.screen = 'tablet';
    } else {
      deviceInfo.screen = 'mobile';
    }
  };

  setScreenWidth();

  watch(screenWidth, () => {
    setScreenWidth();
  });

  return deviceInfo;
}
